// /src/mixins/postMixin.js
import _isUndefined from 'lodash/isUndefined'
import each from 'lodash/each'
import _isArray from 'lodash/isArray'
import { checkNested, deepSearch } from '../components/common/utils/helpers'

// session_type, duration,

export default {
  data() {
    return {
      bookmarkLoading: false,
      completeLoading: false,
      percentViewed: 0,
      timer: null,
      time: 0,
    }
  },

  computed: {
    type() {
      const { post } = this
      if (!_isUndefined(post)) {
        return checkNested(post, 'type') ? post.type : post.post_type
      }
      return false
    },

    id() {
      const { post } = this
      if (!_isUndefined(post)) {
        return post.course_session_id ? post.course_session_id : post.id
      }
    },

    slug() {
      const { post } = this
      if (!_isUndefined(post)) {
        return checkNested(post, 'slug') ? post.slug : post.post_name
      }
    },

    forceRewatch() {
      const { post } = this
      if (!_isUndefined(post)) {
        return checkNested(post, 'force_rewatch') ? post.force_rewatch : false
      }
    },

    cardImage() {
      let output = {}
      const { featured_media, type, logo } = this.post
      if (type == 'relationships' && logo) {
        output = logo
      } else {
        output = featured_media.card
      }

      return output
    },

    postImage() {
      const { featured_media } = this.post
      return featured_media.post
    },

    sessionType() {
      const { session_type } = this.post
      return Array.isArray(session_type) ? session_type.toString() : false
    },

    bookmarkText() {
      if (this.bookmarked == true) {
        return 'Bookmarked'
      }
      return 'Bookmark'
    },

    sessionTypeIcon() {
      const type = this.sessionType ? this.sessionType : this.postType

      switch (type) {
        case 'video':
          return 'fa-play'
        case 'audio':
          return 'fa-microphone'
        case 'downloads':
          return 'fa-download'
        case 'course':
          return 'fa-chalkboard-teacher'
        case 'email':
          return 'fa-envelope-open-text'
        case 'relationships':
          return 'fa-handshake'
        case 'bibleStudies':
          return 'fa-bible'
        default:
          return 'fa-newspaper'
      }
    },

    postType() {
      return this.getPostType()
    },

    routeToName() {
      return this.getRouteToName();
    },

    interactionSet() {
      const { id, type } = this
      return {
        id,
        type,
      }
    },

    relatedContent() {
      let output = []
      if (checkNested(this.post, 'related_content_objs')) {
        // console.log(this.post)
        const { related_content_objs, related_content } = this.post
        if (!_isUndefined(related_content_objs)) {
          each(related_content[0], relatedPostID => {
            if (related_content_objs[relatedPostID] && Object.keys(related_content_objs[relatedPostID]).length > 0) output.push(related_content_objs[relatedPostID])
          })
        }
      }
      return output.length > 0 ? output : false
    },

    currentInteraction: {
      get() {
        const { id, type, slug } = this
        if (!_isUndefined(id) || !_isUndefined(type)) {
          const currentInteraction = this.$store.getters['user/getInteraction'](
            type,
            id,
          )
          // console.log({slug, id, type, currentInteraction})
          return !_isUndefined(currentInteraction)
          ? currentInteraction
          : {id}
        }
      },
      set(updated) {
        return updated
      }
    },

    progress() {
      const { isComplete, isStarted, type } = this
      if (isComplete) {
        return 'Complete'
      }
      if (isStarted) {
        return 'In Progress'
      }
      if (type == 'relationships') {
        return 'Learn More'
      }
      return 'Start ' + this.sessionType
    },

    progressIcons() {
      const { isComplete, isStarted } = this
      if (isComplete) {
        return 'fa fa-check-circle'
      }
      if (isStarted) {
        return 'fa fa-hourglass-half'
      }
      return 'fas fa-arrow-circle-right'
    },

    progressClasses() {
      const { isComplete, isStarted } = this
      if (isComplete) {
        return 'button--success'
      }
      if (isStarted) {
        return 'button--colorWhite'
      }
      return 'button--brandPrimary'
    },

    bookmarkClasses() {
      const { bookmarked } = this
      if (bookmarked) {
        return 'button--accent'
      }

      return 'button--brandPrimary'
    },

    duration() {
      const { duration } = this.post
      return Array.isArray(duration) ? duration[0] : false
    },

    isMVP() {
      const { acf } = this.post
      return deepSearch(acf, ['is_mvp'])
    },

    displayAuthor() {
      const { display_author } = this.post
      if (display_author) {
        const authors =
          Array.isArray(display_author[0]) && display_author[0].length > 0
            ? this.$store.getters['taxies/findItemsByIDArray'](
                'authors',
                display_author[0],
              )
            : false
        return typeof Array.isArray(authors) && authors.length > 0
          ? authors
          : false
      }
      return false
    },

    originTaxonomies() {
      const { origin } = this.post
      let output = [];
      if (origin) {
        const originItems =
          Array.isArray(origin) && origin.length > 0
            ? this.$store.getters['taxies/findItemsByIDArray'](
                'origin',
                origin,
              )
            : false

        return typeof Array.isArray(originItems) && originItems.length > 0
          ? originItems
          : false
      }
      return false
    },

    typeTaxonomies() {
      const { subtitle_groups } = this.post
      let output = [];
      if (subtitle_groups) {
        const subtitleGroups =
          Array.isArray(subtitle_groups) && subtitle_groups.length > 0
            ? this.$store.getters['taxies/findItemsByIDArray'](
                'subtitle_groups',
                subtitle_groups,
              )
            : false
        return typeof Array.isArray(subtitleGroups) && subtitleGroups.length > 0
          ? subtitleGroups
          : false
      }
      return false
    },

    cardTaxonomyDisplay() {
      const { typeTaxonomies } = this
      if (typeTaxonomies) {
        return (
          typeTaxonomies
            .map(a => a.name)
            .join(', ')
            .replace(/\,(?=[^,]*$)/, ' &')
        )
      }
      return false
    },

    authorFeaturing() {
      const { displayAuthor } = this
      if (displayAuthor) {
        return (
          'Featuring: ' +
          displayAuthor
            .map(a => a.name)
            .join(', ')
            .replace(/\,(?=[^,]*$)/, ' &')
        )
      }
      return false
    },

    tagTaxies() {
      const { tags } = this.post
      return Array.isArray(tags) && tags.length > 0
        ? this.$store.getters['taxies/findItemsByIDArray']('tags', tags)
        : false
    },

    bookmarked: {
      get() {
        const { currentInteraction } = this
        return typeof currentInteraction == 'object' &&
          currentInteraction.bookmarked === true
          ? true
          : false
      },
      set(newValue) {
        return newValue
      },
    },

    interactionTime: {
      get() {
        let { interactionTime } = this.currentInteraction
        return !(_isUndefined(interactionTime) || interactionTime === false)  ? interactionTime : 0 
      },
      set(newValue) {
        return newValue
      },
    },

    isComplete: {
      get() {
        if(!_isUndefined(this.currentInteraction)) {
          let { dateCompleted } = this.currentInteraction
          return !(_isUndefined(dateCompleted) || dateCompleted === false)  
        }
      },
      set(newValue) {
        return newValue
      }
    },

    isStarted() {
      if(!_isUndefined(this.currentInteraction)) {
        let { dateStarted } = this.currentInteraction
        return !(_isUndefined(dateStarted) || dateStarted === false)  
      }
    },
  },

  methods: {
    getPostType(defaultPostType) {
      const postType = _isUndefined(defaultPostType) ? this.type : defaultPostType
      switch (postType) {
        case 'session':
          return 'sessions'
        // case 'meeting':
        //   return 'meetings'
        case 'relationship':
          return 'relationships'
        case 'course':
          return 'courses'
        case 'bible-studies':
          return 'bibleStudies'
        default:
          return postType
      }
    },

    getRouteToName(defaultPostType) {
      const postType = _isUndefined(defaultPostType) ? this.type : defaultPostType
      switch (postType) {
        case 'session':
          return 'session'
        case 'relationships':
          return 'relationship'
        case 'funnel-landing':
          return 'funnelLanding'
        case 'course':
          return 'course'
        case 'bible-studies':
          return 'bibleStudy'
        default:
          return postType
        }
    },

    getPercentViewed(totalTime, mediaDuration) {
      const { currentInteraction, sessionType } = this
      let totalInteractionTime = totalTime ? totalTime : currentInteraction.interactionTime
      let duration = mediaDuration ? mediaDuration : currentInteraction.mediaDuration
      if (sessionType == 'audio' || sessionType == 'video') {
        // Guard against division by zero, NaN, or Infinity
        if (duration && isFinite(duration) && duration > 0 &&
            typeof totalInteractionTime != 'undefined' && !_isUndefined(totalInteractionTime) &&
            isFinite(totalInteractionTime)) {
          this.percentViewed = Math.floor((totalInteractionTime / duration) * 100)
        }
      }
    },

    // getRelatedContent(post) {
    //   if (!_isUndefined(post)) {
    //     const { related_content } = post
    //     if (!_isUndefined(related_content) && _isArray(related_content)) {
    //         this.$store.dispatch('posts/getPost', { include: related_content.join(','), title: 'Session' })
    //     }
    //   }
    // },

    addBookmark() {
      this.bookmarkLoading = true
      const { id, type, interactionSet, post } = this
      const bookmark = {
        ...interactionSet,
        bookmarked: !this.bookmarked,
      }
      this.bookmarked = !this.bookmarked
      this.$store
        .dispatch('user/putInteraction', bookmark)
        .then(user => {
          this.bookmarkLoading = false
          const msg =
            user[type][0][id]['bookmarked'] !== false
              ? `You have successfully bookmarked <em><strong>${post.title.rendered}</strong></em>`
              : `You have removed bookmark <em><strong>${post.title.rendered}</strong></em>`
          this.$store.dispatch('notification/add', {
            type: 'notice',
            msg,
            closable: false,
            autoClose: true,
          })
        })
        .catch(err => {
          console.log(err)
        })
    },

    updateInteraction() {
      const { id, type, slug } = this
      if (!_isUndefined(id) || !_isUndefined(type)) {
        const currentInteraction = this.$store.getters['user/getInteraction'](
          type,
          id,
        )
        // console.log({slug, id, type, currentInteraction})
        this.currentInteraction = !_isUndefined(currentInteraction)
        ? currentInteraction
        : false
      }
    },

    markComplete(dateCompleted) {
      let { type, id, interactionSet, isComplete, percentViewed, post } = this
      // if (type !== 'course') {
        // console.log(percentViewed)
        
        if (_isUndefined(dateCompleted) || typeof dateCompleted == 'object') dateCompleted = new Date().toISOString()
        if (!isComplete) {
          this.completeLoading = true
          const completedObj = {
            ...interactionSet,
            dateCompleted,
            percentViewed,
          }
          this.post.dateCompleted = dateCompleted
          this.$store.dispatch('user/putInteraction', completedObj)
            .then(user => {
              this.completeLoading = false
              const title = typeof post.title === 'string' ? post.title : (post.title && post.title.rendered) || 'this session'
              const msg =
                user[type][0][id]['dateCompleted'] !== false
                  ? `You have successfully completed <em><strong>${title}</strong></em>`
                  : `You have removed the completed status <em><strong>${title}</strong></em>`
              this.$store.dispatch('notification/add', {
                type: 'notice',
                msg,
                closable: false,
                autoClose: true,
              })

              this.updateInteraction()

              if (this.$route.name == 'course') this.checkActiveSession()
            })
            .catch(err => {
              console.log(err)
            })

          }
      // }
      
    },

    checkActiveSession() {
      if (this.$route.name == 'course') this.$emit( 'sessioncomplete' )
    },

    visitedPost() {
      const {
        // type,
        // id,
        // currentInteraction,
        // slug,
        post,
        interactionSet,
        isStarted,
      } = this
      if (!_isUndefined(post)) {
        // Wait for user interaction data to load before stamping dates.
        // Without this, dateStarted gets stamped with today's date even if
        // the user already completed the session (user data not yet loaded).
        if (this.currentInteraction === false) {
          setTimeout(() => {
            this.visitedPost()
          }, 1000)
          return
        }
        const date = new Date().toISOString()
        if (!isStarted) {
          const startedObj = {
            ...interactionSet,
            dateStarted: date,
          }

          this.$store.dispatch('user/putInteraction', startedObj)
        }

        setTimeout(() => {
          const visitedObj = {
            ...interactionSet,
            visited: date,
          }
          if (this.type == 'course') {
            if (this.$route.hash !== '') {
              visitedObj['currentSession'] = this.$route.hash.replace('#', '')
              this.$store.dispatch('user/putInteraction', visitedObj)
            }
          } else {
            this.$store.dispatch('user/putInteraction', visitedObj)
          }
  
        }, 2000)
      } else {
        setTimeout(() => {
          this.visitedPost()
        }, 1000)
      }
    },
  },

  // triggering get all posts after post is loaded
  watch: {
    post(post) {
      if (post) {
        // this.$store.dispatch('posts/getAll')
      }
    }
  },

}
